<form *ngIf="form" [formGroup]="form">
    <div class="mat-typography">
        <table>
            <tr>
                <th>
                    Field
                </th>

                <th>
                    Current Value
                </th>

                <th>
                    Desired Value
                </th>

                <th>
                    Status
                </th>
            </tr>

            <tr>
                <td>
                    <div class="info-wrapper">

                        Users can request admin consent to apps they are unable to consent to​
                        <mat-icon
                            [matTooltip]="'If this option is set to yes, then users request admin consent to any app that requires access to data they do not have the permission to grant. If this option is set to no, then users must contact their admin to request to consent in order to use the apps they need.​'">info</mat-icon>
                    </div>
                </td>

                <td>
                    <div>
                        {{ data?.isEnabled ? "Enabled" : "Disabled" }}
                    </div>
                </td>

                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="isEnabled">
                                <mat-option [value]="true">Enable</mat-option>
                                <mat-option [value]="false">Disable</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status [hasError]="errorsString.includes('/isEnabled')"></sway-baseline-status>
                </td>
            </tr>

            <tr [class.disabled-row]="!formValue.isEnabled">
                <td>
                    <div class="info-wrapper">

                        Selected users will receive email notifications for requests
                        <mat-icon
                            [matTooltip]="'
                If this option is set to yes, then selected users will receive email notifications when admin consent requests are created. ​If this option is set to no, then no email notifications will be sent when admin consent requests are created.​'">info</mat-icon>
                    </div>
                </td>

                <td>
                    <div>
                        {{ data?.notifyReviewers ? "Enabled" : "Disabled" }}
                    </div>
                </td>

                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="notifyReviewers">
                                <mat-option [value]="true">Enable</mat-option>
                                <mat-option [value]="false">Disable</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status [hasError]="errorsString.includes('/notifyReviewers')"></sway-baseline-status>
                </td>
            </tr>

            <tr [class.disabled-row]="!formValue.isEnabled">
                <td>
                    <div class="info-wrapper">

                        Selected users will receive request expiration reminders​
                        <mat-icon
                            [matTooltip]="'
                If this option is set to yes, then selected users will receive email notifications when admin consent requests are created. ​If this option is set to no, then no email notifications will be sent when admin consent requests are created.​'">info</mat-icon>
                    </div>
                </td>

                <td>
                    <div>
                        {{ data?.remindersEnabled ? "Enabled" : "Disabled" }}
                    </div>
                </td>

                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="fill">
                            <mat-label>Status</mat-label>
                            <mat-select formControlName="remindersEnabled">
                                <mat-option [value]="true">Enable</mat-option>
                                <mat-option [value]="false">Disable</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('/remindersEnabled')"></sway-baseline-status>
                </td>
            </tr>

            <tr [class.disabled-row]="!formValue.isEnabled">
                <td>
                    <div class="info-wrapper">

                        Consent request expires after (days)​
                        <mat-icon
                        [matTooltip]="'This controls the maximum number of days admin consent requests stay active before expiring. ​​​'">info</mat-icon>
                    </div>
                </td>

                <td>
                    <div>
                        {{ data?.requestDurationInDays }}
                    </div>
                </td>

                <td>
                    <div class="field boolean">
                        <mat-form-field appearance="outline">
                            <input type="number" matInput formControlName="requestDurationInDays"
                                placeholder="Enter number of days" min="1" max="60" />

                            <mat-error *ngIf="form.get('requestDurationInDays')?.hasError('min')">
                                Minimum allowed is 1 day.
                            </mat-error>

                            <mat-error *ngIf="form.get('requestDurationInDays')?.hasError('max')">
                                Maximum allowed is 60 days.
                            </mat-error>

                            <mat-error *ngIf="form.get('requestDurationInDays')?.hasError('required')">
                                This field is required.
                            </mat-error>
                        </mat-form-field>

                    </div>
                </td>

                <td>
                    <sway-baseline-status
                        [hasError]="errorsString.includes('/requestDurationInDays')"></sway-baseline-status>
                </td>
            </tr>



            <tr [class.disabled-row]="!formValue.isEnabled">
                <td rowspan="3">
                    <div class="info-wrapper">

                        Who can review admin consent requests
                        <mat-icon
                            [matTooltip]="'The selected reviewers can act on (review, block, deny) new admin consent requests. All users can block and deny admin consent requests, but only users with the Global, Application, or Cloud application administrator role can grant admin consent.'">
                            info
                        </mat-icon>
                    </div>
                </td>
                <td>
                    <div>
                        <strong>Users:</strong>
                        {{currentUsers?.length}}
                    </div>

                </td>
                <td>
                    <strong>
                        Users:
                    </strong>
                    <span class="number">{{ form.get('includeUsers')?.value?.length || 0 }}</span>

                    <div *ngIf="!readOnly || override?.includes('users')" class="btn-wrapper mt-2">
                        <button (click)="manageItems('includeUsers')" mat-button color="primary">Manage</button>
                    </div>
                </td>
                <td rowspan="3">
                    <sway-baseline-status [hasError]="errorsString.includes('/reviewers')"></sway-baseline-status>

                </td>
            </tr>

            <tr [class.disabled-row]="!formValue.isEnabled">
                <td>
                        <strong>Groups:</strong>
                        {{currentGroups?.length}}
                </td>
                <td>
                    <strong>
                        Groups:
                        <span class="number">{{ form.get('includeGroups')?.value?.length || 0 }}</span>
                    </strong>
                    <div *ngIf="!readOnly || override?.includes('groups')" class="btn-wrapper mt-2">
                        <button (click)="manageItems('includeGroups')" mat-button color="primary">Manage</button>
                    </div>
                </td>
            </tr>

            <tr [class.disabled-row]="!formValue.isEnabled">
                <td>
                        <strong>Roles:</strong>
                        {{currentRoles?.length}}
                </td>

                <td>
                    <strong>
                        Roles:
                    </strong>
                    <span class="number">{{ form.get('includeRoles')?.value?.length || 0 }}</span>

                    <div *ngIf="!readOnly || override?.includes('roles')" class="btn-wrapper mt-2">
                        <button (click)="manageItems('includeRoles')" mat-button color="primary">Manage</button>
                    </div>
                </td>
            </tr>
        </table>
    </div>
</form>
